'use client';
import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { SPONSORS_DATA } from '@/lib/mediaConfig';

export default function SponsorsSection() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);

  // Duplicate sponsors for seamless infinite scroll
  const allSponsors = [...SPONSORS_DATA, ...SPONSORS_DATA];

  return (
    <section id="sponsors" className="py-20 bg-surface/20 overflow-hidden">
      <div className="divider-gold mb-20" />
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">Our Sponsors</p>
          <h2 className="text-2xl font-bold text-foreground">Backed by Industry Leaders</h2>
        </div>
      </div>
      {/* Premium carousel */}
      <div
        className="relative"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: 'linear-gradient(to right, var(--background), transparent)' }} />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: 'linear-gradient(to left, var(--background), transparent)' }} />

        <div
          ref={trackRef}
          className="flex gap-6 px-6"
          style={{
            animation: isPaused ? 'none' : 'sponsorScroll 28s linear infinite',
            width: 'max-content',
          }}
        >
          {allSponsors?.map((sp, idx) => (
            <div
              key={`${sp?.id}-${idx}`}
              className="glass-card glass-card-hover px-6 py-4 rounded-2xl flex items-center gap-4 cursor-pointer flex-shrink-0 min-w-[200px]"
            >
              {/* Sponsor logo image */}
              <div className="relative w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-muted/30">
                <Image
                  src={sp?.logo?.src}
                  alt={sp?.logo?.alt}
                  fill
                  className="object-cover"
                  sizes="48px"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                  <span className="text-primary font-extrabold text-xs">{sp?.initials}</span>
                </div>
              </div>
              <div>
                <p className="font-bold text-sm text-foreground whitespace-nowrap">{sp?.name}</p>
                <p className="text-xs text-primary">{sp?.tier} Sponsor</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="divider-gold mt-20" />
      <style jsx>{`
        @keyframes sponsorScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}